import React from 'react';
import styles from './Ellipse.module.scss';

export const Ellipse: React.FC = () => {
  return <div className={styles.ellipse} />;
};
